import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button, notification, Tooltip } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { Row, Form, Input, Col, Select, Collapse, Popconfirm } from "antd";
import { EditOutlined, DeleteOutlined, InfoCircleFilled, CheckCircleOutlined } from "@ant-design/icons";

import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import { MinusCircleTwoTone, PlusCircleTwoTone } from "@ant-design/icons";
import jsPDF from 'jspdf';
import QuestionnairesApi from "../../common/Apis/QuestionnairesApi";
import RecipeApi from "../../common/Apis/RecipeApi";
import EmptyBox from "../../common/CommonUI/EmptyBox";
import Pagination from "../../common/Pagination/Pagination"; 
import "../../common/Pagination/Pagination.css"; 

const Recipe = () => {
  const navigate = useNavigate();
  const { Content } = Layout;
  const { Panel } = Collapse;
  const [Recipes, setRecipe] = React.useState([]);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [totalElements, setTotalElements] = useState(0);


  const getRecipe = useCallback(() => {
    RecipeApi.ListRecipe(PaginatePage, PaginateLimit).then((response) => {
      settotalPages(response.totalPages);
      setRecipe(response.payloadDto);
      setTotalElements(response.totalElements);

    })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const [PaginatePage, setPaginatePage] = useState(0);
  const [PaginatetotalPages, settotalPages] = useState(null);
  const [PaginateLimit, setPaginateLimit] = useState(10);
  const [formPaginate] = Form.useForm();
  formPaginate.setFieldsValue({
    paginate: PaginateLimit,
  });
  const handlesetPaginateLimit = (value) => {
    setPaginateLimit(value);
    setCurrentPage(1);
    formPaginate.setFieldsValue({
      paginate: value,
    });
    RecipeApi.ListRecipe(0, value)
      .then((response) => {
        settotalPages(response.totalPages);
        setRecipe(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  };


  function formatDate(date) {
    const dateNew = parseInt(date, 10);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const formattedDate = new Date(dateNew).toLocaleDateString(
      "en-US",
      options
    );

    const [month, day, year] = formattedDate.split(" ");
    const capitalizedMonth = month.toUpperCase();
    return `${day} ${capitalizedMonth} ${year}`;
  }

  const handlePrintButtonClick2 = () => {
    const fontSize = 12;
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: [297, 210],
    });

    let yPos = 35;
    doc.setFontSize(fontSize);
    console.log("PaginatetotalPages")
    console.log(PaginatetotalPages)
    const currentDate = new Date().toLocaleDateString();
    const currentTime = new Date().toLocaleTimeString();
    const promises = [];

    for (let i = 0; i < parseInt(PaginatetotalPages); i++) {
      promises.push(
        RecipeApi.ListRecipe(i, PaginateLimit).then((response) => {
          doc.setFont('Poppins', 'bold');
          doc.text(`Recipe`, 150, 10, { align: 'center' });
          doc.setFont('Poppins', 'normal');
          doc.setFontSize(10);
          doc.text(`Date : ${currentDate}`, 10, 20);
          doc.text(`Time : ${currentTime}`, 10, 25);
          doc.setFontSize(fontSize);

          // Draw table headers and borders
          doc.setFont('Poppins', 'bold');
          doc.text('Recipe', 15, yPos);
          doc.text('Qty', 70, yPos);
          doc.text('No.Ingredients', 100, yPos);
          doc.text('Refrigerated', 190, yPos);
          doc.text('Allergens', 250, yPos);
          doc.setFont('Poppins', 'normal');
          doc.setLineWidth(0.1);
          doc.rect(12, yPos - 5, 280, 10);
          yPos += 10;
          response.payloadDto.forEach(row => {
            const recipeName = row?.recipeName;
            const qty = row?.quantity + " " + row?.unit;
            const status = row?.ingredientsDTO?.map(item => item?.name)?.join('/ ');
            const date = row?.refrigeratedMeal === true ? 'Yes' : 'No';
            const userInfo = row?.allergenDTOList?.map(item => item?.allergensName)?.join('/ ');
            doc.setFontSize(fontSize);

            doc.text(recipeName, 15, yPos);
            doc.text(qty, 70, yPos);
            doc.text(status, 100, yPos);
            doc.text(date, 190, yPos);
            const allergenLines = doc.splitTextToSize(userInfo, 40);
            doc.text(allergenLines, 250, yPos);

            const rowHeight = 10 * Math.max(allergenLines.length, 1);

            if (yPos + rowHeight + 10 > 297) { // Check if remaining space is not enough for next row
              doc.addPage();
              yPos = 35; // Reset yPos for the new page
            } else {
              doc.setLineWidth(0.1);
              doc.rect(12, yPos - 5, 280, rowHeight);
              yPos += rowHeight;
            }
          });

          if (i === parseInt(PaginatetotalPages)) {
            doc.addPage();
            yPos = 35;
          }
        }).catch((err) => {
          console.log(err);
        })
      );
    }

    const reversedPromises = promises.map(promise =>
      promise.then(result =>
        new Promise(resolve =>
          setTimeout(() => resolve(result), 0)
        )
      )
    );

    Promise.all(reversedPromises)
      .then(() => {
        window.open(doc.output('bloburl'), '_blank');
      })
      .catch((err) => {
        console.log(err);
      });

  };


  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    let pageNew = page - 1
    RecipeApi.ListRecipe(pageNew, PaginateLimit)
      .then((response) => {
        setPaginatePage(pageNew)
        settotalPages(response.totalPages);
        setRecipe(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  };
  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  useEffect(() => {
    getRecipe();
    PageLoading();
  }, [getRecipe, PageLoading]);



  const handleRemovefilterRecipe = (FiltergetRecipeIndex) => {
    const newfilterRecipe = [...filterRecipe];
    newfilterRecipe.splice(FiltergetRecipeIndex, 1);
    setFilterRecipe(newfilterRecipe);
    if (FiltergetRecipeIndex == 0) {
      getRecipe();
    }
  };
  const handleClear = () => {
    getRecipe();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    setFilterRecipe([
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };
  const formRef = useRef(null);

  const [filterRecipe, setFilterRecipe] = useState([
    {
      title: "",
      answerType: "",
      name: "",
    },
  ]);

  const handleAddfilterRecipe = () => {
    setFilterRecipe([
      ...filterRecipe,
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };

  const handleSubmit = (data) => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    let singleLineString = filterRecipe
      .map((obj) => {
        if (obj.answerType === "%") {
          return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
        } else if (obj.answerType === "=") {
          return `${obj.title}${obj.answerType}${obj.name}`;
        } else {
          return `${obj.title}=${obj.name}`;
        }
      })
      .join("&");

    let filderData = window.btoa(
        "componentCode=RECIPE&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
    );
    QuestionnairesApi.FilterQuestionsetNext(filderData, 0, PaginateLimit)
      .then((response) => {
        setCurrentPage(1);
        settotalPages(response.totalPages);
        setRecipe(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => { });
  };
  const handleChangeTitle = (FiltergetRecipeIndex, value) => {
    const newfilterRecipe = [...filterRecipe];
    newfilterRecipe[FiltergetRecipeIndex].title = value;
    setFilterRecipe(newfilterRecipe);
  };
  const handleChangeAnswertype = (FiltergetRecipeIndex, value) => {
    const newfilterRecipe = [...filterRecipe];
    newfilterRecipe[FiltergetRecipeIndex].answerType = value;
    setFilterRecipe(newfilterRecipe);
  };

  const handleChangename = (FiltergetRecipeIndex, value) => {
    const newfilterRecipe = [...filterRecipe];
    newfilterRecipe[FiltergetRecipeIndex].name = value;
    setFilterRecipe(newfilterRecipe);
  };

  const paginatedData = Recipes;

  const renderTableRows = () => {
    if (paginatedData?.length > 0) {
      return paginatedData.map((item) => (
        <tr key={item?.id} className="text-center">
          <td style={{ width: "22%" }} className="pt-3">
            {item?.recipeName}
          </td>
          <td style={{ width: "10%" }} className="pt-3 ">
            {item?.quantity} {item?.unit}
          </td>
          <td style={{ width: "10%", textAlign: 'center' }} className="pt-3 ">
            {(item?.ingredientsDTO?.length > 0) ? (
              <Tooltip placement="top" title={(
                <div>
                  {item?.ingredientsDTO?.map(ingredients => (
                    <React.Fragment key={ingredients.id}>
                      {ingredients.name}
                      <br />
                    </React.Fragment>
                  ))}
                </div>
              )}>
                <p>{item?.ingredientsDTO?.length}</p>
              </Tooltip>
            ) : null}

          </td>
          <td style={{ width: "10%", textAlign: 'center' }} className="pt-3 ">
            {item?.refrigeratedMeal === true ? <CheckCircleOutlined className="inforIcon" /> : ''}
          </td>
          <td style={{ width: "8%", textAlign: 'center' }} className="pt-3">

            {(item?.allergenDTOList?.length > 0) ? (
              <Tooltip placement="top" title={(
                <div>
                  {item?.allergenDTOList?.map(allergen => (
                    <React.Fragment key={allergen.id}>
                      {allergen.allergensName}
                      <br />
                    </React.Fragment>
                  ))}
                </div>
              )}>
                <InfoCircleFilled className="inforIcon" />
              </Tooltip>
            ) : null}

          </td>
          <td style={{ width: "15%" }}>
            <div className="d-flex ">
              <Link
                to={`/masters/recipe/edit-recipe?id=${item.id}`}
                className={decodedToken?.permissions?.some(
                  (permission) => permission?.authority === 'EDIT_RECIPE'
                ) ? 'btn btn-primary btn-save table-action icon-center w-100' : 'd-none'}
              >
                <EditOutlined />
                Edit
              </Link>
              <Popconfirm
                title="Are you sure ?"
                description="Do you really want to delete this Recipe ?"
                okText="Yes"
                onConfirm={() => handleDeleteRecipe(item.id)}
                placement="topRight"
                className="w-100"
                cancelText="No"
              >
                <Link
                  to={``}
                  className={decodedToken?.permissions?.some(
                    (permission) => permission?.authority === 'DELETE_RECIPE'
                  ) ? 'btn btn-primary btn-back table-action icon-center mx-1' : 'd-none'}
                >
                  <DeleteOutlined />
                  Delete
                </Link>
              </Popconfirm>
            </div>
          </td>
        </tr>
      ));
    } else {
      return (
        <tr className="text-center EmptyTable">
          <td colSpan={6} className="text-center ">
            <EmptyBox />
            <br />
            {/* <Link
              className={decodedToken?.permissions?.some(
                (permission) => permission?.authority === 'ADD_RECIPE'
              ) ? 'btn btn-primary btn-save m-0 my-2' : 'd-none'}
              to={'/masters/recipe/add-recipe'}
            >
              Add Recipe
            </Link> */}
            <Button
              type="primary"
              onClick={() => navigate('/masters/recipe/add-recipe')}
              style={{
                display: decodedToken?.permissions?.some(
                  permission => permission?.authority === 'ADD_RECIPE'
                ) ? '' : 'none',
                height: 'auto',
                lineHeight: 'normal',
                alignItems: 'center',
                padding: '5px 24px',
              }}
            >
              Add new recipe
            </Button>
          </td>
        </tr>
      );
    }
  };

  const handleDeleteRecipe = (RecipeID) => {
    RecipeApi.DeleteRecipe(RecipeID)
      .then((response) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Deleted</span>,
          description: "Delete Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        PageLoading();
        getRecipe();
      })
      .catch((err) => {
        if (err.apiError.status) {
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };


  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader onPrintResponse2={handlePrintButtonClick2} />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}
        <div
          style={{
            padding: "20px",
            paddingBottom: "5px",
          }}
        >
          <Form
            ref={formRef}
            name="nest-messages"
            layout="vertical"
            className="FormClass FilterForm"
            onFinish={handleSubmit}
          >
            <>
              <Collapse>
                <Panel
                  header={
                    <h5 className="mb-0">
                      <b>Filter</b>
                    </h5>
                  }
                  key="1"
                >
                  {filterRecipe.map((input, filterRecipeIndex) => (
                    <div key={filterRecipeIndex}>
                      <Row gutter={24} className="pt-2">
                        <Col lg={5} md={5} className="px-1">
                          <Form.Item
                            name={`title${filterRecipeIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select"
                              placeholder="Filter By"
                              value={input.title}
                              onChange={(value) =>
                                handleChangeTitle(filterRecipeIndex, value)
                              }
                              options={[
                                {
                                  value: "recipeName",
                                  label: "Recipe",
                                }
                              ]}
                            />
                          </Form.Item>
                        </Col>

                        <Col lg={4} md={4} className="px-1">
                          <Form.Item
                            name={`type${filterRecipeIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select type.",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select mb-1"
                              placeholder="Condition"
                              onChange={(value) =>
                                handleChangeAnswertype(
                                  filterRecipeIndex,
                                  value
                                )
                              }
                              options={[
                                { value: "%", label: "Matches with" },
                                {
                                  value: "=",
                                  label: "Equals to",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>

                        <Col lg={5} md={5} className="px-1">
                          <Form.Item
                            name={`name${filterRecipeIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please enter Text.",
                              },
                            ]}
                          >
                            <Input
                              type="text"
                              onChange={(e) =>
                                handleChangename(
                                  filterRecipeIndex,
                                  e.target.value
                                )
                              }
                              placeholder="Text"
                              className="control-input"
                            />
                          </Form.Item>
                        </Col>

                        <Col lg={8} md={10} className="px-1">
                          <Form.Item className="text-lable">
                            {filterRecipeIndex == 0 ? (
                              <>
                                <Row gutter={23} className="mb-3">
                                  <Col span={2} className="mx-0">
                                    <Form.Item className="text-lable">
                                      <PlusCircleTwoTone
                                        onClick={handleAddfilterRecipe}
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={10}>
                                    <Button
                                      type="primary"
                                      htmlType="submit"
                                      className="btn btn-primary btn-save table-action icon-center "
                                    >
                                      Filter
                                    </Button>
                                  </Col>
                                  <Col span={10}>
                                    <Button
                                      type="reset"
                                      htmlType="reset"
                                      onClick={() => handleClear()}
                                      style={{ color: "#0b5ed7" }}
                                      className="btn btn-primary btn-back table-action icon-center"
                                    >
                                      Clear
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            ) : (
                              <>
                                {" "}
                                <MinusCircleTwoTone
                                  onClick={() =>
                                    handleRemovefilterRecipe(
                                      filterRecipeIndex
                                    )
                                  }
                                />
                              </>
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </Panel>
              </Collapse>
            </>
          </Form>
        </div>
        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <div>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                {paginatedData?.length > 0 && (
                  <Button
                    type="primary"
                    onClick={() => navigate('/masters/recipe/add-recipe')}
                    style={{
                      display: decodedToken?.permissions?.some(
                        permission => permission?.authority === 'ADD_RECIPE'
                      ) ? '' : 'none',
                      height: 'auto',
                      lineHeight: 'normal',
                      alignItems: 'center',
                      padding: '5px 24px',
                    }}
                  >
                    Add new recipe
                  </Button>
                )}
              </div>
              <div>

                <Form
                  form={formPaginate}
                >
                  <Form.Item
                    name="paginate"
                    className="text-lable"
                    style={{ width: '100px' }}
                  >
                    <Select
                      className="control-Select"
                      onChange={(value) => {
                        handlesetPaginateLimit(value)
                      }}
                      options={[
                        { value: 10, label: "10" },
                        { value: 20, label: "20" },
                        { value: 30, label: "30" },
                        { value: 40, label: "40" },
                        { value: 50, label: "50" },
                      ]}
                    />
                  </Form.Item>
                </Form>

              </div>
            </div>
            <table className="table users-table">
              <thead>
                <tr>
                  <th>Recipe</th>
                  <th>Qty</th>
                  <th className="text-center">No.Ingredients</th>
                  <th className="text-center">Refrigerated</th>
                  <th className="text-center">Allergens</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>{renderTableRows()}</tbody>
            </table>
            {paginatedData?.length > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={PaginatetotalPages}
              onPageChange={handlePageChange}
              maxVisiblePages={5}
              showPageInfo={true}
              totalItems={totalElements}
              pageSize={PaginateLimit}
            />
          )}
          </div>
        </Content>

        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default Recipe;
